import { useCallback, useState } from "react";
import { useDebouncedUrlMatcher } from "@infrastructure/Hooks/useDebouncedUrlMatcher";

export function useLinkout(
    contentToMatch: string,
    initialLinkoutValue: string = "",
) {
    const [linkoutUrl, setLinkoutUrl] = useState(initialLinkoutValue);
    const [matchedUrl, setMatchedUrl] = useState("");
    const [linkoutCleared, setLinkoutCleared] = useState(false);

    useDebouncedUrlMatcher(contentToMatch, (match) => {
        if (contentToMatch.length === 0) {
            setLinkoutCleared(false);
        }

        if (!linkoutCleared) {
            setMatchedUrl(match ?? "");
        }
    });

    const clearLinkout = useCallback(() => {
        setLinkoutCleared(true);
        setLinkoutUrl("");
        setMatchedUrl("");
    }, []);

    return {
        linkoutUrl: linkoutUrl ? linkoutUrl : matchedUrl,
        setLinkoutUrl,
        clearLinkout,
    };
}
